import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select', 'otherField', 'otherInput']

  connect() {
    this.selectTarget.addEventListener('change', () => this.toggle())
    this.toggle()
  }

  toggle() {
    const isOther = this.selectTarget.value === 'その他'
    this.otherFieldTarget.style.display = isOther ? 'block' : 'none'
    if (isOther) {
      this.otherInputTarget.classList.add('required')
    } else {
      this.otherInputTarget.classList.remove('required')
      this.otherInputTarget.value = ''
    }
  }
}
